var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3047 0.555664H2.69358C2.12631 0.555664 1.58227 0.781011 1.18115 1.18213C0.780034 1.58325 0.554688 2.12728 0.554688 2.69455V37.3057C0.554688 37.5865 0.610012 37.8647 0.717501 38.1242C0.82499 38.3837 0.98254 38.6195 1.18115 38.8181C1.37977 39.0167 1.61556 39.1743 1.87506 39.2817C2.13456 39.3892 2.41269 39.4446 2.69358 39.4446H21.3214V24.3751H16.2658V18.5418H21.3214V14.1668C21.2166 13.1396 21.3379 12.102 21.6766 11.1267C22.0154 10.1514 22.5634 9.262 23.2823 8.52091C24.0011 7.77981 24.8734 7.20497 25.838 6.83668C26.8025 6.4684 27.8359 6.3156 28.8658 6.389C30.3792 6.37968 31.8919 6.45759 33.3964 6.62233V11.8723H30.3047C27.8547 11.8723 27.388 13.039 27.388 14.7307V18.4834H33.2214L32.463 24.3168H27.388V39.4446H37.3047C37.5856 39.4446 37.8637 39.3892 38.1232 39.2817C38.3827 39.1743 38.6185 39.0167 38.8171 38.8181C39.0157 38.6195 39.1733 38.3837 39.2808 38.1242C39.3883 37.8647 39.4436 37.5865 39.4436 37.3057V2.69455C39.4436 2.41367 39.3883 2.13554 39.2808 1.87604C39.1733 1.61653 39.0157 1.38074 38.8171 1.18213C38.6185 0.983516 38.3827 0.825967 38.1232 0.718477C37.8637 0.610988 37.5856 0.555664 37.3047 0.555664Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.bb28746f574af59561f57eb4082eb114.svg";
export { ForwardRef as ReactComponent };